import type { ErrorToastCode, ErrorToastConfig } from '../types';

export const ERROR_TOAST_CONFIG: Record<ErrorToastCode, ErrorToastConfig> & {
  default: ErrorToastConfig;
} = {
  401: {
    message:
      'You don\u2019t have access to this artifact or version. You may still be able to access other artifacts. To request access, reach out to airkeysupport@capitalone.com',
  },
  404: {
    message:
      'File could not be downloaded. Please refresh the page and try again.',
  },
  500: {
    message:
      'File could not be downloaded. Please refresh the page and try again.',
  },
  default: {
    message: 'Something went wrong. Please try again later.',
  },
};
